
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class LabourMasterDialog extends Serenity.EntityDialog<LabourMasterRow, any> {
        protected getFormKey() { return LabourMasterForm.formKey; }
        protected getIdProperty() { return LabourMasterRow.idProperty; }
        protected getLocalTextPrefix() { return LabourMasterRow.localTextPrefix; }
        protected getNameProperty() { return LabourMasterRow.nameProperty; }
        protected getService() { return LabourMasterService.baseUrl; }
        protected getDeletePermission() { return LabourMasterRow.deletePermission; }
        protected getInsertPermission() { return LabourMasterRow.insertPermission; }
        protected getUpdatePermission() { return LabourMasterRow.updatePermission; }

        protected form = new LabourMasterForm(this.idPrefix);

        constructor() {
            super();

            q.setTextRightAlign(this.form.FromWt);
            q.setTextRightAlign(this.form.ToWt);
            q.setTextRightAlign(this.form.PurStdLabour);
            q.setTextRightAlign(this.form.SaleStdLabour);

            q.hideCategorylinks(this.element, true);
            q.setTextRightAlign(this.form.MaxLabour);
            q.setTextRightAlign(this.form.MinLabour);
            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.cascadeField = "CategoryId";
                this.form.SubCategoryId.cascadeValue = this.form.CategoryId.value;

            });
            this.form.ItemTypeId.changeSelect2(e => {
                if (this.form.ItemTypeId.value == "104") {
                    this.form.ProductTypeId.cascadeField = "ItemTypeId";
                    this.form.ProductTypeId.cascadeValue = this.form.ItemTypeId.value;
                    this.form.ProcessId.cascadeField = "ItemTypeId";
                    this.form.ProcessId.cascadeValue = this.form.ItemTypeId.value;
                    q.hideField(this.form.IsCustomerItem);
                }
                else if (this.form.ItemTypeId.value == "105") {
                    this.form.ProductTypeId.cascadeField = "ItemTypeId";
                    this.form.ProductTypeId.cascadeValue = this.form.ItemTypeId.value;
                    this.form.ProcessId.cascadeField = "ItemTypeId";
                    this.form.ProcessId.cascadeValue = this.form.ItemTypeId.value;
                    q.showAndEnableField(this.form.IsCustomerItem);


                }
                else {
                    //this.form.BaseItemTypeId.value = "";
                    this.form.ProductTypeId.cascadeField = "ItemTypeId";
                    this.form.ProductTypeId.cascadeValue = this.form.ItemTypeId.value;
                    this.form.ProcessId.cascadeField = "ItemTypeId";
                    this.form.ProcessId.cascadeValue = this.form.ItemTypeId.value;
                    q.hideField(this.form.IsCustomerItem);

                }
            });

            this.form.ProcessId.changeSelect2(e => {
                this.form.CalcOnId.cascadeField = "ProcessId";
                this.form.CalcOnId.cascadeValue = this.form.ProcessId.value;
                Q.reloadLookup(OMS.ProcessMasterRow.lookupKey);
                var isSetting = OMS.ProcessMasterRow.getLookup().itemById[this.form.ProcessId.value].IsSetting;
                if (isSetting)
                    q.showAndSetRequiredField(this.form.SettingId);
                else
                    q.hideField(this.form.SettingId);

            })

            //FrmWt and ToWt Validation        
            this.form.FromWt.changeSelect2(e => {
                try {
                    var FrmWt = this.form.FromWt.value;
                    var ToWt = this.form.ToWt.value;

                    if (ToWt == null) {
                        ToWt = FrmWt;
                        if (FrmWt != null && FrmWt < ToWt) {
                            Q.notifyError("Frm Wt Cannot be Greater than To Wt");
                            this.form.FromWt.element.focus();
                        }
                    }

                    if (ToWt != null) {
                        if (FrmWt != null && FrmWt > ToWt) {
                            Q.notifyError("Frm Wt Cannot be Greater than To Wt");
                            this.form.FromWt.element.focus();
                        }
                    }
                }
                catch (undefined) {
                }
            });

            this.form.ToWt.changeSelect2(e => {
                try {

                    var FrmWt = this.form.FromWt.value;
                    var ToWt = this.form.ToWt.value;

                    if (FrmWt == null) {
                        Q.notifyError("To Wt Cannot be Lesser than Frm Wt");
                        this.form.FromWt.element.focus();

                    }

                    if (FrmWt != null) {
                        if (ToWt != null && FrmWt > ToWt) {

                            Q.notifyError("To Wt Cannot be Lesser than Frm Wt");
                            this.form.ToWt.element.focus();
                        }
                    }
                }
                catch (undefined) {
                }
            });




            //Mimimum and Max Validation 
            this.form.MinLabour.changeSelect2(e => {
                try {

                    var MinLabour = this.form.MinLabour.value;
                    var MaxLabour = this.form.MaxLabour.value;

                    if (MaxLabour == null) {
                        MaxLabour = MinLabour;
                        if (MinLabour != null && MinLabour < MaxLabour) {
                            Q.notifyError("Min Labour Cannot be Greater than Max Labour");
                            this.form.MinLabour.element.focus();
                        }
                    }

                    if (MaxLabour != null) {
                        if (MinLabour != null && MinLabour > MaxLabour) {
                            Q.notifyError("Min Labour Cannot be Greater than Max Labour");
                            this.form.MinLabour.element.focus();
                        }
                    }

                }
                catch (undefined) {
                }
            });

            this.form.MaxLabour.changeSelect2(e => {
                try {

                    var MinLabour = this.form.MinLabour.value;

                    var MaxLabour = this.form.MaxLabour.value;

                    if (MinLabour == null) {
                        Q.notifyError("Max Labour Cannot be Lesser than Min Labour");
                        this.form.MinLabour.element.focus();
                    }

                    if (MinLabour != null) {
                        if (MaxLabour != null && MinLabour > MaxLabour) {
                            Q.notifyError("Max Labour Cannot be Lesser than Min Labour");
                            this.form.MaxLabour.element.focus();
                        }
                    }



                }
                catch (undefined) {
                }
            });



            this.form.PurStdLabour.changeSelect2(e => {
                var PurStdLabour = this.form.PurStdLabour.value;
                var RateType = this.form.RateType.value;
                if (RateType == "1" && PurStdLabour > 100) {
                    Q.notifyError("Rate Cannot Exceed 100");
                    this.form.PurStdLabour.element.focus();
                }

            });

            this.form.SaleStdLabour.changeSelect2(e => {
                var SaleStdLabour = this.form.SaleStdLabour.value;
                var RateType = this.form.RateType.value;
                if (RateType == "1" && SaleStdLabour > 100) {
                    Q.notifyError("Rate Cannot Exceed 100");
                    this.form.SaleStdLabour.element.focus();
                }


            });

            this.form.ItemTypeId.changeSelect2(e => {
                this.setfields();
            });

        }
        protected onDialogOpen() {
            this.setfields();

        }

        setfields() {
            if (this.form.ItemTypeId.value == "101") {
                var LabourType = (TabAurous.GetConfigValue(1002)); 
                switch (LabourType) {
                    case "1":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.showAndSetRequiredField(this.form.CategoryId);
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                        q.showAndSetRequiredField(this.form.BrandId);
                        q.showAndSetRequiredField(this.form.CollectionId);
                        q.showAndSetRequiredField(this.form.SuperTypeId);
                        break;
                    case "2":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.showAndSetRequiredField(this.form.CategoryId);
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                        q.hideField(this.form.BrandId);
                        q.hideField(this.form.CollectionId);
                        q.hideField(this.form.SuperTypeId);
                        break;
                    case "3":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.showAndSetRequiredField(this.form.CategoryId);
                        q.hideField(this.form.SubCategoryId);
                        q.hideField(this.form.BrandId);
                        q.hideField(this.form.CollectionId);
                        q.hideField(this.form.SuperTypeId);
                        break;
                    case "4":
                        q.hideField(this.form.ProductTypeId);
                        q.showAndSetRequiredField(this.form.CategoryId);
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                        q.hideField(this.form.BrandId);
                        q.hideField(this.form.CollectionId);
                        q.hideField(this.form.SuperTypeId);
                        break;
                    case "5":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.hideField(this.form.CategoryId);
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                        q.hideField(this.form.BrandId);
                        q.hideField(this.form.CollectionId);
                        q.hideField(this.form.SuperTypeId);
                        break;
                    case "6":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.hideField(this.form.CategoryId);
                        q.hideField(this.form.SubCategoryId);
                        q.hideField(this.form.BrandId);
                        q.hideField(this.form.CollectionId);
                        q.showAndSetRequiredField(this.form.SuperTypeId);
                        break;
                    case "7":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.hideField(this.form.CategoryId);
                        q.hideField(this.form.SubCategoryId);
                        q.hideField(this.form.BrandId);
                        q.hideField(this.form.CollectionId);
                        q.hideField(this.form.SuperTypeId);
                        break;

                }
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.StoneSizeId);

            }
            else if (this.form.ItemTypeId.value == "105") {
                let IsSetting: boolean = false;
                if (!Q.isEmptyOrNull(this.form.ProcessId.value))
                    IsSetting = OMS.ProcessMasterRow.getLookup().itemById[this.form.ProcessId.value].IsSetting;

                if (IsSetting)
                    q.showAndSetRequiredField(this.form.SettingId);
                else
                    q.hideField(this.form.SettingId);
                var SLabourType = (TabAurous.GetConfigValue(1028));
                switch (SLabourType) {
                    case "1":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.showAndSetRequiredField(this.form.CategoryId);
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                        q.showAndSetRequiredField(this.form.StoneColorId);
                        q.showAndSetRequiredField(this.form.QualityId);
                        q.showAndSetRequiredField(this.form.ShapeId);
                        q.showAndSetRequiredField(this.form.SieveId);
                        q.showAndSetRequiredField(this.form.StoneSizeId);

                        break;
                    case "2":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.showAndSetRequiredField(this.form.CategoryId);
                        q.hideField(this.form.SubCategoryId);
                        q.hideField(this.form.StoneColorId);
                        q.hideField(this.form.QualityId);
                        q.hideField(this.form.ShapeId);
                        q.hideField(this.form.SieveId);
                        q.hideField(this.form.StoneSizeId);
                        break;
                    case "3":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.showAndSetRequiredField(this.form.CategoryId);
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                        q.hideField(this.form.SubCategoryId);
                        q.hideField(this.form.StoneColorId);
                        q.hideField(this.form.QualityId);
                        q.hideField(this.form.ShapeId);
                        q.hideField(this.form.SieveId);
                        q.hideField(this.form.StoneSizeId);

                        break;
                    case "4":
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                        q.hideField(this.form.CategoryId);
                        q.hideField(this.form.SubCategoryId);
                        q.hideField(this.form.BrandId);
                        q.hideField(this.form.CollectionId);
                        q.hideField(this.form.SuperTypeId);
                        q.hideField(this.form.StoneColorId);
                        q.hideField(this.form.QualityId);
                        q.showAndSetRequiredField(this.form.ShapeId);
                        q.hideField(this.form.SieveId);
                        q.hideField(this.form.StoneSizeId);
                        break;
                }

                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);

            } else {
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SettingId);

            }
        }

        //private confirmBeforeDelete(oldEvt, e) {
        //    let self = this;
        //    var id = LabourMasterRow.getLookup().items.filter(x => x.AttributeId.toString() == this.form.AttributeId.value.toString())[0];
        //    var refid = LabourPriceListDetailsRow.getLookup().items.filter(x => x.AttributeId == id.AttributeId)[0];
        //    if (refid != null) {
        //        if (refid.AttributeId != null || refid.AttributeId > 0) {
        //            Q.alert("Labour is in use, Cannot delete");
        //            return;
        //        }
        //    } else {
        //        LabourMasterService.Delete(
        //            {

        //                EntityId: this.entityId
        //            }, response => {
        //                Serenity.SubDialogHelper.triggerDataChange(self);
        //                self.dialogClose();
        //                window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
        //            });
        //    }

        //}
    }
}